import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import rpc from '@tencent/vft-rpc-tool';
export default function dailyAdd() {
  return _dailyAdd.apply(this, arguments);
}

function _dailyAdd() {
  _dailyAdd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return rpc('trpc.qqlivekid.xqe_cny_bulladd.WriteServ', 'DailyAdd', {
              task_id: 'xiaoqie'
            }, {
              withCredentials: true,
              method: 'post'
            });

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _dailyAdd.apply(this, arguments);
}

export function getAdd() {
  return _getAdd.apply(this, arguments);
}

function _getAdd() {
  _getAdd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return rpc('trpc.qqlivekid.xqe_cny_bulladd.WriteServ', 'GetBulladd', {
              task_id: 'xiaoqie'
            }, {
              withCredentials: true,
              method: 'post'
            });

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getAdd.apply(this, arguments);
}